export const actionTypes = {
  REQUEST_START: 'MY_TAXES.INSURANCE_TAXES.REQUEST_START',
  REQUEST_START_SKIP_LOADING: 'MY_TAXES.INSURANCE_TAXES.REQUEST_START.SKIP_LOADING',
  REQUEST_SUCCESS: 'MY_TAXES.INSURANCE_TAXES.REQUEST_SUCCESS',
  REQUEST_FAILURE: 'MY_TAXES.INSURANCE_TAXES.REQUEST_FAILURE',
};

export function startRequest() {
  return {
    type: actionTypes.REQUEST_START,
  };
}

export function startRequestSkipLoading() {
  return {
    type: actionTypes.REQUEST_START_SKIP_LOADING,
  };
}

export function requestSuccess(data) {
  return {
    type: actionTypes.REQUEST_SUCCESS,
    payload: data,
  };
}

export function requestFailure(error) {
  return {
    type: actionTypes.REQUEST_FAILURE,
    payload: error,
  };
}
